// user-api.js
import { ProtectedHttpClient, PublicHttpClient } from "../shared/clients/http-client";

const UserApi = {
  public: {
    login: (firebaseToken) =>
      PublicHttpClient.post("/auth/fb/generate-token", {
        token: firebaseToken,
      }),
      loginB2C: (firebaseToken) =>
      PublicHttpClient.post("/auth/b2c", {
        token: firebaseToken,
      }),
      refreshToken: (refreshToken) =>
      PublicHttpClient.post("/auth/refresh", {
        token: refreshToken,
      }),
    checkEmail: (email) =>
      PublicHttpClient.post("/auth/check-email", {
        email,
      }),
    signup: (payload) =>
      PublicHttpClient.post("/auth/signup", payload),
  },
  private: {
    getUserProfile: () => ProtectedHttpClient.get("/user/profile"), // Requires token
    updateUserProfile: (data) => ProtectedHttpClient.put("/user/profile", data), // Requires token
    updateUser: (userId, data) => ProtectedHttpClient.patch(`/user/${userId}`, data), // Requires token
    getUsersWithPagination: (filters = {}, paginationOptions = {}) =>
      ProtectedHttpClient.post("/users", filters, { params: paginationOptions }), // Requires token
  },
};

export default UserApi;
